// @ts-nocheck
import axios from "axios"
import endpoints from '../../config/endpoints.config'

const createUser = async (username: string, password: string, email: string) => {
    return await axios.post(endpoints.auth.createUser, {
        username,
        password,
        email
    })
}

export default createUser